<template>
  <div class="def_wrap">
    <p class="type">
      <span class="title">2024年01月 综合所得预扣预缴表</span>
    </p>
    <el-table
        :data="tableData"
        style="width: 100%"
        max-height="calc(100vh - 260px)"
        border>
      <el-table-column prop="name" label="所得项目名称" />
      <el-table-column prop="person" align="center" label="填写人数">
        <template #default="{row}">
          <span v-if="row.name == '正常工资薪金' && currentQa.sonQueType == '51'">{{ userAnswer.length }}</span>
          <span v-else-if="row.name == '全年一次性奖金收入' && currentQa.sonQueType == '52'">{{ userAnswer.length }}</span>
          <span v-else-if="row.name == '劳务报酬(一般、法律援助补贴、其他非连续劳务)' && currentQa.sonQueType == '53'">{{ userAnswer.length }}</span>
          <span v-else>{{row.person || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="total" align="center" label="收入额合计">
        <template #default="{row}">
          <span v-if="row.name == '全年一次性奖金收入' && currentQa.sonQueType == '52'">{{ summaryInfo.srz }}</span>
          <span v-else-if="row.name == '劳务报酬(一般、法律援助补贴、其他非连续劳务)' && currentQa.sonQueType == '53'">{{ summaryInfo.srz }}</span>
          <span v-else-if="row.name == '正常工资薪金' && currentQa.sonQueType == '51'">{{ summaryInfo.srz }}</span>
          <span v-else>{{row.Answer_CurrentIncome || '0.00'}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="status" align="center" label="状态" >
        <template #default>
              {{ isFill ?'已填写':'未填写' }}
          </template>
      </el-table-column> -->
      <el-table-column align="center" label="填写">
        <template #default="scope">
          <el-button type="primary" link @click="changeTab(scope)">
            填写
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { useTaxStore } from "@/store/modules/tax.js";
import Big from "big.js";
import {
  useBeforeTaxSummary,
} from "@/views/examCenter/tax/components/consolidatedIncome/components/fourStatistCommon.js";
const taxStore = useTaxStore();
const { userAnswer, personCollectionList } = storeToRefs(taxStore);

const currentQa = inject('provideCurrentQa');
const tableData = ref([
  { name: "正常工资薪金", person: 0, total: "0.00", status: "未填写", sonQueType: '51', },
  { name: "全年一次性奖金收入", person: 0, total: "0.00", status: "已填写", sonQueType: '52' },
  { name: "内退一次性补偿金", person: 0, total: "0.00", status: "已填写" },
  { name: "年金领取", person: 0, total: "0.00", status: "已填写" },
  {
    name: "解除劳动合同一次性补偿金",
    person: 1,
    total: "0.00",
    status: "已填写",
  },
  {
    name: "央企负责人绩效薪金延期兑现收入和任期奖励",
    person: 0,
    total: "0.00",
    status: "已填写",
  },
  { name: "单位低价向职工售房", person: 0, total: "0.00", status: "已填写" },
  {
    name: "劳务报酬(保险营销员、证券经纪人、其他连续劳务)",
    person: 0,
    total: "0.00",
    status: "已填写",
  },
  {
    name: "劳务报酬(一般、法律援助补贴、其他非连续劳务)",
    person: 0,
    total: "0.00",
    status: "已填写",
    sonQueType: '53',
  },
  {
    name: "稿酬所得",
    person: 1,
    total: "0.00",
    status: "已填写",
  },
  {
    name: "特许权使用费所得",
    person: 1,
    total: "0.00",
    status: "已填写",
  },
  { name: "提前退休一次性补贴", person: 1, total: "0.00", status: "已填写" },
  { name: "税收递延型商业养老金", person: 1, total: "0.00", status: "已填写" },
  { name: "个人股权激励收入", person: 1, total: "0.00", status: "已填写" },
]);

const emits = defineEmits(["changeTab"]);
const changeTab = (scope) => {
  const { $index } = scope;
  if (currentQa.value.sonQueType == '51' && $index == 0) { //工资薪金题
    emits("changeTab", "one");
  } else if (currentQa.value.sonQueType == '52' && $index == 1) { //全年奖金题
    emits("changeTab", "one52");
  } else if (currentQa.value.sonQueType == '53' && $index == 8) { // 劳务报酬题
    emits("changeTab", "one53");
  }
};

const isFill = computed(() => {
  if (personCollectionList.value.length > 0 && userAnswer.value.length > 0) {
    return true;
  }
  return false;
});

const summaryInfo = computed(() => {
  let srz = new Big(0), msSrz = new Big(0)
  userAnswer.value.forEach(row => {
    srz = srz.plus(row.Answer_CurrentIncome) //收入总额
    msSrz = msSrz.plus(row.Answer_CurrentExemptIncome) //免税收入总
  })
  return {
    srz: srz.toFixed(2),
    msSrz: msSrz.toFixed(2),
  }
})

const {resDataList} = useBeforeTaxSummary()

watch(resDataList, (newVal) => {
  if (newVal?.length) {
    newVal.forEach(row => {
      const find = tableData.value.find(f => f.sonQueType && f.sonQueType == row.sonQueType)
      if (find) {
        find.person = row.person
        find.Answer_CurrentIncome = row.Answer_CurrentIncome
      }
    })
  }
})

</script>

<style lang="scss" scoped>
.def_wrap {
  width: 100%;
  width: 100%;
  .type {
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .title {
      height: 20px;
      border-left: 4px solid var(--el-color-primary);
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 12px;
    }
  }
  :deep(.el-table) {
    --el-table-header-bg-color: #f8f9fa;
  }
}
</style>
